import React from 'react';
import {t} from 'i18next';
import ArrActionButton from '../../../components/common/arr-action-button/ArrActionButton';
import {Box, Typography} from '@mui/material';

const ActionButtonDemo: React.FC = () => {
  const menuItem = [
    {label: 'Bulk tag', id: '1'},
    {label: 'Bulk Folder', id: '2'},
    {label: 'Bulk Assign', id: '3'},
    {
      id: '4',
      label: 'View',
      submenu: [
        {
          id: t('actionButton.menu.label_ViewDoc'),
          label: t('actionButton.menu.label_ViewDoc'),
        },
        {
          id: t('actionButton.menu.label_viewDoc_newtab'),
          label: t('actionButton.menu.label_viewDoc_newtab'),
        },
        {
          id: t('actionButton.menu.labe_viewDocList'),
          label: t('actionButton.menu.labe_viewDocList'),
        },
      ],
    },
  ];

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        ArrActionButton Demo
      </Typography>
      <ArrActionButton
        menuItems={menuItem}
        size={'medium'}
        direction="bottom-right"
        dataTestId="action-button-demo"
      />
    </Box>
  );
};

export default ActionButtonDemo;
